module.exports = __webpack_public_path__ + "img/icon-16-back-2.2c1bd188.svg";